// @flow

import React from "react";

import PulseLoader from "src/components/PulseLoader";

const PanelItem = () => <PulseLoader w="100%" h="34px" />;

export default PanelItem;
